module.exports = "<div>Logging out, please wait...</div>\r\n"